import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/api/admin/company/users.service';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { constants } from 'src/app/constants';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  status = constants.USER.STATUS;
  statusSelected = constants.USER.STATUS[0].status;

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private userService: UsersService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&status=' +
      this.statusSelected;
    this.userService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
    // setTimeout(() => {
    // }, 500);
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  changeStatus() {
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.statusSelected = constants.USER.STATUS[0].status;
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/empresa/usuarios/editar',
      id
    ]);
  }

  delete(item: any, _index: any) {
    let options = {
      title: '¿Estás segur@?',
      message: item.username,
      cancel: 'Cancelar',
      confirm: 'DAR DE BAJA'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.userService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success(
              'El registro ' + item.username + ' se ha dado de baja con éxito'
            );
            this.list();
          }
        });
      }
    });
  }

  activedUser(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message: '¿Esta seguro(a) de activar al usuario '+item.username+' ?',
      cancel: 'Cancelar',
      confirm: 'ACTIVAR USUARIO'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.userService.activedUser(item.id, item).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success(
              'El usuario ' + item.username + ' ha sido activado con éxito'
            );
            this.list();
          }
        });
      }
    });
  }
}
